import { render, staticRenderFns } from "./hospitalSumMore.vue?vue&type=template&id=7b524016&scoped=true&"
import script from "./hospitalSumMore.vue?vue&type=script&lang=js&"
export * from "./hospitalSumMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b524016",
  null
  
)

export default component.exports